module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei3.svg";